// @ts-strict-ignore
import interpolateComponents from 'interpolate-components';
import React from 'react';
import styled from 'styled-components';

import { PrimaryButton } from 'components/Button';
import { TrackedLink } from 'components/Link';
import { breakpoints, colors } from 'theme';

const AcceptCookiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${colors.white};
  color: ${colors.greyishBrown};
  text-align: center;
  padding: 12px;
  border-top: solid 1px ${colors.silver};
  @media (min-width: ${breakpoints[2]}) {
    height: 56px;
    flex-direction: row;
    border-top: solid 1px ${colors.silver};
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const AcceptCookies = ({
  acceptCookies,
  submitting,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  acceptCookies: (...args: Array<any>) => any;
  submitting: boolean;
}) => (
  <AcceptCookiesContainer data-qa-id="accept-cookies-alert">
    <div>
      {interpolateComponents({
        mixedString:
          /* TRANSLATORS: accept cookie message in page footer for EU */
          getText(
            'This site uses cookies. By continuing to use our site, you agree to our use of cookies as described in our {{link}}Cookie Policy{{/link}}.'
          ),
        components: {
          link: (
            <TrackedLink
              href="https://info.idealist.org/cookie-policy/"
              eventName="Resource Page"
            />
          ),
        },
      })}
    </div>
    <PrimaryButton
      size="small"
      ml={[0, 0, 0, 3]}
      mt={[2, 0, 0, 0]}
      onClick={acceptCookies}
      disabled={submitting}
      data-qa-id="accept-cookies-button"
    >
      {
        /* TRANSLATORS: accept cookies button text */
        getText('OK')
      }
    </PrimaryButton>
  </AcceptCookiesContainer>
);

// eslint-disable-next-line import/no-default-export
export default AcceptCookies;
